import { handleActions } from 'redux-actions';
import pick from 'lodash/pick';
import {
  addNotificationToQueue,
  removeNotificationFromQueue,
  NotificationQueueItem,
  removeQueues,
} from './actionCreators';
import { NotificationQueueStateSlice } from './types';
import { reduxKey } from './constants';

const MAX_NOTIFICATION_AGE = 60000;

function isValidNotification(item: NotificationQueueItem) {
  // do not expire notifications during tests
  if (process.env.NODE_ENV === 'test') {
    return true;
  }

  return Date.now() - item.created < MAX_NOTIFICATION_AGE;
}

const handler = handleActions<NotificationQueueStateSlice, any>(
  {
    [addNotificationToQueue.toString()]: (
      state,
      { payload: { notification, queueName } }: ReturnType<typeof addNotificationToQueue>
    ) => {
      const queue = (state[queueName] || []).filter(isValidNotification);
      return { ...state, [queueName]: [...queue, notification] };
    },
    [removeNotificationFromQueue.toString()]: (
      state,
      { payload: { queueName, id } }: ReturnType<typeof removeNotificationFromQueue>
    ) => {
      if (!state[queueName]) {
        return state;
      }
      const queue = state[queueName].filter(isValidNotification);
      return { ...state, [queueName]: queue.filter(item => item.id !== id) };
    },
    [removeQueues.toString()]: (
      state,
      { payload: { predicate } }: ReturnType<typeof removeQueues>
    ) => {
      const queues = Object.keys(state).filter(queueName =>
        queueName === 'default' ? true : !predicate(queueName)
      );

      // Inferred typing on pick here is a bit bad
      return pick(state, queues) as NotificationQueueStateSlice;
    },
  },
  { default: [] }
);

export default {
  [reduxKey as string]: handler,
};
